import { useRef } from 'react';
import { useQuery } from 'react-query';
import dictionaryService from '../../service/Dictionary.service';
import styles from '../../styles/Dictionary.module.css';
import { InferGetResultHasText_Response } from '../../types/DictionaryTypes';

const Search = () => {
  const textRef = useRef<HTMLTextAreaElement>(null);
  const { error, refetch } = useQuery<InferGetResultHasText_Response | undefined, Error>('getResult', async () => {
    if (textRef.current && textRef.current.value) {
      const sentence = textRef.current.value.trim();
      const { data } = await dictionaryService.getResult(sentence);
      const { results, dictionaries, error: error2 } = data;
      if (error2) alert('번역에 실패했습니다.');
      return { sentence, results: results!, dictionaries: dictionaries! };
    }
  }, { refetchOnWindowFocus: false });
  const onSearch = (e: any) => {
    e.preventDefault();
    refetch();
    if (error) alert('번역 실패 ' + error);

  };
  return (
    <form className={styles.d_search} onSubmit={onSearch}>
      <div className={styles.group}>
        <h2>Smart Dictionary</h2>
        <div className={styles.d_search_form}>
          <textarea ref={textRef} placeholder='영어 문장을 입력해주세요.' title='영어 문장 입력'></textarea>
          <button><i className={styles.ic_earth}>번역이미지</i>번역하기</button>
        </div>
      </div>
    </form>
  );
};

export default Search;
